import {
  DEFAULT_WORKFORCE_VIEW,
  useBookingModuleStore,
  useCalendarRoot,
  useWorkforceProfilesDataIfAvailable
} from "PFApp/booking/store";
import { CalendarView } from "PFApp/booking/types";
import { CalendarRoot } from "PFApp/booking/types/calendar_root";
import { isWorkforceProfiles } from "PFApp/booking/utils/calendar_root.utils";
import useIsPermittedTo, { useIsCurrentUserPermittedTo } from "PFCore/helpers/use_is_permitted_to";
import { useCurrentProfile } from "PFCore/hooks/queries/profile";
import { PermissionRule } from "PFTypes";
import { useEffect } from "react";

export const useResetCalendarView = () => {
  const { data: currentProfile } = useCurrentProfile();
  const isPermittedTo = useIsPermittedTo(currentProfile);
  const isWallPlannerAvailable = isPermittedTo(PermissionRule.WallPlannerAccess);
  const isGridViewEnabled = useIsCurrentUserPermittedTo(PermissionRule.GridView);

  const calendarRoot = useCalendarRoot();
  const { view } = useWorkforceProfilesDataIfAvailable("view");
  const workforceActions = useBookingModuleStore((state) =>
    isWorkforceProfiles(calendarRoot) ? state.actions[CalendarRoot.WorkforceProfiles] : null
  );

  useEffect(() => {
    if (!isWorkforceProfiles(calendarRoot)) {
      return;
    }

    const isInvalidView = view && !Object.values(CalendarView).includes(view);
    const isWallPlannerViewUnavailable = view === CalendarView.WallPlanner && !isWallPlannerAvailable;
    const isGridViewUnavailable = view === CalendarView.Grid && !isGridViewEnabled;

    if (!view || isInvalidView || isWallPlannerViewUnavailable || isGridViewUnavailable) {
      workforceActions?.setView(DEFAULT_WORKFORCE_VIEW);
    }
  }, [view, isWallPlannerAvailable, isGridViewEnabled]);
};
